import Immutable from 'immutable';

import { ActionTypes } from './actions';

export const initialState = Immutable.fromJS({});

const setRejectionOperations = (state, { rejectionOperationsData }) => {
  if (!rejectionOperationsData) return state;
  return state.merge({ rejectionOperationsData });
};

const setOeesDates = (state, { rejectionData }) => {
  if (!rejectionData) return state;
  return state.merge({ rejectionData });
};

const setOeesHours = (state, { rejectionHoursData }) => {
  if (!rejectionHoursData) return state;
  return state.merge({ rejectionHoursData });
};

const setOeesShifts = (state, { rejectionShiftsData }) => {
  if (!rejectionShiftsData) return state;
  return state.merge({ rejectionShiftsData });
};

const setRejectionOperationsLoaderStatus = (state, { rejectionOperationsLoader }) => {
  return state.merge({ rejectionOperationsLoader });
};

const setJobRejectionConfirmationModaldData = (state, { JobRejectionConfirmationModaldData }) => {
  return state.merge({ JobRejectionConfirmationModaldData });
};
const setRejectionFilter = (state, { addRejection }) => {
  return state.merge({ addRejection });
};

const setShiftRejection = (state, { shiftRejectionData, shiftRejectionParams, clear }) => {
  if (clear) {
    return state.merge({ shiftRejectionData: null, shiftRejectionParams: null });
  }
  if (shiftRejectionData === null || shiftRejectionData === undefined) return state;
  return state.merge({
    shiftRejectionData,
    shiftRejectionParams: shiftRejectionParams || null,
  });
};

export const callbacks = [
  {
    actionType: ActionTypes.SET_REJECTION_OPERATIONS,
    actionFunction: setRejectionOperations,
  },
  {
    actionType: ActionTypes.SET_OEE_DATES,
    actionFunction: setOeesDates,
  },

  {
    actionType: ActionTypes.SET_OEE_HOURS,
    actionFunction: setOeesHours,
  },

  {
    actionType: ActionTypes.SET_OEE_SHIFTS,
    actionFunction: setOeesShifts,
  },

  {
    actionType: ActionTypes.SET_REJECTION_OPERATIONS_LOADER_STATUS,
    actionFunction: setRejectionOperationsLoaderStatus,
  },
  {
    actionType: ActionTypes.SET_JOB_REJECTION_CONFIRMATION_MODAL_DATA,
    actionFunction: setJobRejectionConfirmationModaldData,
  },
  {
    actionType: ActionTypes.SET_REJECTION_FILTER,
    actionFunction: setRejectionFilter,
  },
  {
    actionType: ActionTypes.SET_SHIFT_REJECTION,
    actionFunction: setShiftRejection,
  },
];
